import { render, staticRenderFns } from "./RecurringOrdersReport.vue?vue&type=template&id=d8457bbc&scoped=true&"
import script from "./RecurringOrdersReport.vue?vue&type=script&lang=js&"
export * from "./RecurringOrdersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8457bbc",
  null
  
)

export default component.exports